var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("simple-list", {
    ref: "menuList",
    attrs: {
      "server-items": _vm.items,
      query: "sectionId",
      variant: "menu-list-" + _vm.columns,
    },
    scopedSlots: _vm._u(
      [
        _vm.selectedSectionData
          ? {
              key: "banner",
              fn: function () {
                return [
                  _vm.bannerImageExist && _vm.selectedSectionData.title
                    ? _c("div", { staticClass: "banner-wrapper" }, [
                        _c("div", { staticClass: "banner-image" }, [
                          _c(
                            "picture",
                            {
                              directives: [
                                {
                                  name: "lazyload",
                                  rawName: "v-lazyload",
                                  value: {
                                    src: _vm.selectedSectionData.imageSrc,
                                    variant: "link-highlight",
                                  },
                                  expression:
                                    "{ src: selectedSectionData.imageSrc,\n                        variant: 'link-highlight' }",
                                },
                              ],
                              key: "banner-image-" + _vm.selectedSectionData.id,
                              staticClass: "image-wrapper",
                            },
                            [
                              _c("img", {
                                staticClass: "image",
                                attrs: {
                                  src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                                  alt: _vm.selectedSectionData.imageAlt,
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "banner-content" }, [
                          _c("div", { staticClass: "banner-title" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.selectedSectionData.title) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "banner-description",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.selectedSectionData.description
                              ),
                            },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "filter",
          fn: function () {
            return [
              _c("accessible-tabs", [
                _vm.headerTabVisibility
                  ? _c(
                      "div",
                      {
                        ref: "menuListHeader",
                        staticClass: "menu-list-header",
                        class: { "carousel-active": _vm.showCarousel },
                      },
                      [
                        _vm.showCarousel
                          ? _c(
                              "carousel",
                              {
                                key: "carousel-" + _vm.sections.length,
                                attrs: {
                                  selector: ".carousel-wrapper",
                                  variant: "menu-tabs",
                                },
                              },
                              [
                                _c("div", { staticClass: "carousel" }, [
                                  _c(
                                    "div",
                                    {
                                      ref: "menuListHeaderCarousel",
                                      staticClass:
                                        "filter-items carousel-wrapper",
                                      attrs: { role: "tablist" },
                                    },
                                    _vm._l(_vm.sections, function (section, i) {
                                      return _c(
                                        "button",
                                        {
                                          key: section.id,
                                          staticClass:
                                            "filter-item tab-group-button",
                                          class: [
                                            {
                                              active:
                                                _vm.selectedSectionId ===
                                                section.id,
                                            },
                                          ],
                                          attrs: {
                                            id: "menu-filter-" + i,
                                            type: "button",
                                            "aria-controls": section.label,
                                            tabindex:
                                              _vm.selectedSectionId ==
                                              section.id
                                                ? "0"
                                                : "-1",
                                            role: "tab",
                                            "aria-selected":
                                              _vm.selectedSectionId ===
                                              section.id,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.filterSection(
                                                $event,
                                                section.id
                                              )
                                            },
                                            keydown: [
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "right",
                                                    39,
                                                    $event.key,
                                                    ["Right", "ArrowRight"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 2
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.filterSection(
                                                  $event,
                                                  i === _vm.sections.length - 1
                                                    ? null
                                                    : _vm.sections[i + 1].id
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "left",
                                                    37,
                                                    $event.key,
                                                    ["Left", "ArrowLeft"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 0
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.filterSection(
                                                  $event,
                                                  i === 0
                                                    ? null
                                                    : _vm.sections[i - 1].id
                                                )
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(section.label) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showCarousel
                          ? _c(
                              "div",
                              {
                                staticClass: "filter-items",
                                attrs: { role: "tablist" },
                              },
                              _vm._l(_vm.sections, function (section, i) {
                                return _c(
                                  "button",
                                  {
                                    key: section.id,
                                    staticClass: "filter-item tab-group-button",
                                    class: [
                                      {
                                        active:
                                          _vm.selectedSectionId === section.id,
                                      },
                                    ],
                                    attrs: {
                                      id: "menu-filter-" + i,
                                      type: "button",
                                      tabindex:
                                        _vm.selectedSectionId == section.id
                                          ? "0"
                                          : "-1",
                                      "aria-controls": section.label,
                                      role: "tab",
                                      "aria-selected":
                                        _vm.selectedSectionId === section.id,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.filterSection(
                                          $event,
                                          section.id
                                        )
                                      },
                                      keydown: [
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "right",
                                              39,
                                              $event.key,
                                              ["Right", "ArrowRight"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (
                                            "button" in $event &&
                                            $event.button !== 2
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.filterSection(
                                            $event,
                                            i === _vm.sections.length - 1
                                              ? null
                                              : _vm.sections[i + 1].id
                                          )
                                        },
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "left",
                                              37,
                                              $event.key,
                                              ["Left", "ArrowLeft"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (
                                            "button" in $event &&
                                            $event.button !== 0
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.filterSection(
                                            $event,
                                            i === 0
                                              ? null
                                              : _vm.sections[i - 1].id
                                          )
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(section.label) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "rendered-list",
          fn: function (ref) {
            var items = ref.items
            return [
              _c(
                "ul",
                _vm._l(items, function (item) {
                  return _c(
                    "li",
                    { key: item.id },
                    [
                      _c("menu-card", {
                        key: item.id,
                        attrs: {
                          "menu-item": item,
                          "grid-columns": parseInt(_vm.columns),
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }